<template>
    <div class="page-content">
        <div class="components-box">
            <downBtnVue :data="data.headerInfo"></downBtnVue>
            <introduceVue :data="data.hdbjInfo" v-if="!data.hdbjInfo?.disShow"></introduceVue>
            <featureVue :data="data.hdtsInfo" v-if="!data.hdtsInfo?.disShow"></featureVue>
            <timeVue :data="data.hdsjInfo" v-if="!data.hdsjInfo?.disShow"></timeVue>
            <awardsVue :data="data.jxszInfo" v-if="!data.jxszInfo?.disShow"></awardsVue>
            <fieldVue :data="data.hglyInfo" v-if="!data.hglyInfo?.disShow"></fieldVue>
            <rulesVue :data="data.pxgzInfo" v-if="!data.pxgzInfo?.disShow"></rulesVue>
            <committeeVue :data="data.pswyhInfo" v-if="!data.pswyhInfo?.disShow"></committeeVue>
            <organizeVue :data="data.zzjgInfo" v-if="!data.zzjgInfo?.disShow"></organizeVue>
        </div>
    </div>
</template>

<script setup>
import downBtnVue from '../components/mobile/downBtn.vue';//底部报名
import introduceVue from '../components/mobile/introduce.vue';//活动背景
import featureVue from '../components/mobile/feature.vue';//活动特色
import timeVue from '../components/mobile/time.vue';//活动时间
import awardsVue from '../components/mobile/awards.vue';//奖项设置
import fieldVue from '../components/mobile/field.vue';//涵盖领域
import rulesVue from '../components/mobile/rules.vue';//评选规则
import committeeVue from '../components/mobile/committee.vue';//评审委员会
import organizeVue from '../components/mobile/organize.vue';//组织机构

const props = defineProps({
  data: {
    type: Object,
    default: () => {
      return {}
    }
  }
})

</script>

<style lang="scss" scoped>
.page-content{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 100px;
    .components-box{
        width: 100%;
        padding: 0 24px 24px;
    }
}
</style>
